import React, {useState, useEffect} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Input, Icon, Modal, Card, CheckBox } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View, Linking } from 'react-native';
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage, hideMessage } from "react-native-flash-message";
import { setTaskStatus } from '../../../store/actions/request';
import {ServiceInfo} from './service.js'
import * as RootNavigation from '../../../root.navigation.js';

import {useSelector, useDispatch} from 'react-redux';


const CallIcon = (props) => (
  <Icon {...props}  name='phone-call'/>
);

const BookmarkIcon = (props) => (
  <Icon {...props}  name='bookmark'/>
);
const AddIcon = (props) => (
  <Icon {...props}  name='person-add'/>
);
const DangerIcon = (props) => (
  <Icon {...props}  name='alert-triangle-outline'/>
);



const  width= Dimensions.get('window').width
export const CustomerInfo = ( props ) => {
  const data = useSelector( state => state.request.data);
  const user =  useSelector( state => state.login.information);
  const dispatch = useDispatch();
  const [modal2, setModal2] = useState(false)
  const [selectedSub, setSelectedSub] = useState(0)
  const [subs, setSubs] = useState([])

  const dial = ()=>{
    let phoneNumber = `tel:${data.merchant_phone}`;
    if (Platform.OS === 'android') { phoneNumber = `tel:${data.merchant_phone}`; }
    else {phoneNumber = `telprompt:${data.merchant_phone}`; }
    Linking.openURL(phoneNumber);
  }
  const getSubsets = async() =>{
    const token =  await AsyncStorage.getItem('userId');

    const response = await trackerApi.post('/app/getSubsets', {}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) setSubs(response.data.subsets)
    else showMessage({
        message: `خطای دسترسی به دیتابیس`,
        type: "danger",
      });
  }
  useEffect (() => {
    getSubsets()
  }, [])

  const accept_req = async()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/update/request_status', {reqID: data.id, status:'doing' } , {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status){
      showMessage({
        message: response.data.message,
        type: "success",
        duration: 4000
      });
      dispatch(setTaskStatus('accept'));
      // props.stepFunction({...data, status:'accept'})
      // setData({...data, status:'accept'})
    }
    else{
      showMessage({
        message: response.data.message,
        type: "danger",
      });
    }
  }

  const forwardReq = async()=>{
    // setModal2(true)
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/app/addSubsetToReq', {reqID: data.id, agent_phone: subs[selectedSub].subset } , {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status){
      setModal2(false)
      showMessage({
        message: response.data.message,
        type: "success",
        duration: 4000
      });
      RootNavigation.navigate('Menu')

    //   // dispatch(setTaskStatus('accept'));
    //   // props.stepFunction({...data, status:'accept'})
    //   // setData({...data, status:'accept'})
    }
    else{
      setModal2(false)
      showMessage({
        message: response.data.message,
        type: "danger",
      });
    }
  }
  return (
        <View style={{width, justifyContent:'space-between', alignItems:'flex-start'}}>
          <View style={{flex:1, flexDirection:'row', backgroundColor:'#134A93'}}>
            <View style={{ backgroundColor:'#134A93', flex:1}}>
              <Text category='c1' style={{marginHorizontal:5, marginTop:5, color:'#f5f5f5'}}>تاریخ تخصیص {data.register_date.split('T')[0]} ساعت {data.register_date.split('T')[1]}</Text>
              <Divider style={{marginTop:5, marginHorizontal:10, marginRight:50}} />
              <Text category='h6' appearance='hint' style={{marginHorizontal:5, marginTop:5}}>اطلاعات مشتری</Text>
              <View style={{flexDirection:'row',marginHorizontal:5, marginTop:5, alignItems:'center', justifyContent:'space-between'}}>
                <Text style={{color:'#f5f5f5'}}>{data.merchant_name}</Text>
                <Text style={{color:'#f5f5f5', marginRight:20}}>{data.merchant_phone}</Text>

              </View>


              <View style={{flexDirection:'row',marginHorizontal:5, marginTop:5, alignItems:'center'}}>
                <Text style={{color:'#f5f5f5', lineHeight:23}}>آدرس: {data.merchant_city}، {data.merchant_address}</Text>
              </View>
              <View style={{ alignItems:'center' ,marginHorizontal:5, marginTop:15,width, flexDirection:'row'}}>
                <Text category='c1' appearance='hint'>مدل دستگاه: </Text>
                <Text style={{color:'#f5f5f5'}}>{data.product_category} {data.product_model}</Text>
              </View>
            </View>
            <View style={{marginHorizontal:8, alignItems:'center', justifyContent:'space-between'}}>
                <Layout level='3' style={{ borderRadius:10, marginTop:10, borderWidth:1, borderColor:'#134A93AS' }}>
                  <Text appearance='hint' category='c1' style={{marginHorizontal:5}}>شماره کار: </Text>
                  <Text status='primary' category='h4' style={{marginHorizontal:10, textAlign:'center'}}>{data.id}</Text>
                </Layout>
              <Layout style={{flex:1 , backgroundColor:'#134A93', alignItems:'center'}} >
              { data.service_type ==='تعمیر' &&
                <Image style={{width:45, height:45, marginVertical:5, marginHorizontal:10}} source={require('../../../assets/service.png')} />
              }
              { data.service_type !='تعمیر' &&
                <Image style={{width:45, height:45, marginVertical:5, marginHorizontal:10}} source={require('../../../assets/install.png')} />
              }
                <Text  style={{marginBottom:10 ,color:'#f5f5f5'}}>{data.service_type}</Text>

              </Layout>


            </View>
          </View>
          <View style={{backgroundColor:'#134A93'}}>
          <Layout level='3' style={{ borderTopRightRadius:15, borderTopLeftRadius:15, }}>

            <View style={{justifyContent:'center', alignItems:'center', width}}>
              <Input
                disabled
                label='مشکل دستگاه'
                style={{marginHorizontal:15, borderRadius:10, marginTop:10, width:width-30}}
                placeholder ={data.problem}
                accessoryLeft= {DangerIcon}
                multiline={true}
                />
              </View>
              { !data.status && user.supervisor == '1' &&
              <Button style={{borderRadius:10, marginHorizontal:15, marginTop: 10}} onPress={()=>setModal2(true)} accessoryLeft={AddIcon} appearance='outline' status='info'>انتقال به زیر مجموعه</Button>
              }
            <View style={{flexDirection:'row',justifyContent:'flex-end', width, alignItems:'flex-end', paddingTop:15, paddingHorizontal:15}}>
              { !data.status &&
              <Button style={{borderRadius:10, marginHorizontal:10}} onPress={accept_req} accessoryLeft={BookmarkIcon} appearance='outline' status='warning'>پذیرش</Button>
              }
              <Button style={{borderRadius:10}} accessoryLeft={CallIcon} appearance='outline' onPress={dial}>تماس با مشتری</Button>
            </View>

          </Layout>

          </View>
          { !data.status  &&
            <ServiceInfo />
          }
          <Modal
             visible={modal2}
             backdropStyle={styles.backdrop}
             onBackdropPress={() => setModal2(false)}>
             <Card disabled={false}>

             <Text category='h6' status='primary' style={{marginBottom:10}}>انتقال قبض پذیرش</Text>
             <View style={{justifyContent:'flex-end'}}>
             {
               subs.map((item, index)=>{
                 return(
                   <CheckBox
                     style={{ marginHorizontal:15, marginTop:10, marginBottom: 10}}
                     checked={selectedSub === index}
                     onChange={nextChecked => setSelectedSub(index)}
                     key={index}
                     >
                     <Text>
                      {item.subsetName}
                     </Text>

                   </CheckBox>
                 )
               })
             }
             </View>

               <Button style={{marginHorizontal:5, marginTop: 20}} onPress={()=>{forwardReq()}}>
                  انتقال
                </Button>
             </Card>
           </Modal>
        </View>

  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
  box:{
    borderRadius:10,
    width:width-10,
    marginHorizontal:10,
    marginVertical:5,
    padding:10
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
